import React from 'react';

type StrongTextProps = {
    rowText: string;
    inputString: string;
};

export const StrongText: React.FC<StrongTextProps> = ({ rowText, inputString }) => {
    // 入力内容をスペースで分割
    const keyswords = inputString
        .trim()
        .split(/[ \u3000\t]/)
        .filter((word) => word.length > 0);
    if (keyswords.length === 0) return <>{rowText}</>;

    // 正規表現パターンを作成
    const pattern = keyswords.map((word) => word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|');
    const regex = new RegExp(`(${pattern})`, 'gi');
    // 文言を正規表現パターンで分割
    const parts = rowText.split(regex);

    return (
        <span style={{ whiteSpace: 'pre-wrap' }}>
            {parts.map((part, index) =>
                regex.test(part) ? (
                    <strong key={index}>{part}</strong>
                ) : (
                    <React.Fragment key={index}>{part}</React.Fragment>
                )
            )}
        </span>
    );
};
